import { ObservableMap, ObservableLocalStorageVariable, ObservableArray } from "@lexriver/observable"
import { TypeEvent } from '@lexriver/type-event'

import { IFavorites } from "./IFavorites"
import { StringMethods} from '@lexriver/string-methods'
import { ServerProducts } from "../server-queries/ServerProducts"
import { GlobalState } from "../GlobalState"

export class FavoritesInLocalStorage implements IFavorites {

    // protected products:JsonProduct[] = []

    protected productIdsO = new ObservableArray<number>()
    // protected productIds = new ObservableMap<string, number>()
    public onChangeEvent: TypeEvent<() => void> = new TypeEvent()
    public onFavoritesEmptyOrNotEvent: TypeEvent<(isEmpty: boolean) => void> = new TypeEvent()

    protected prevIsEmpty: boolean = true
    constructor() {
        //#region create favoritesInLocalStorage as ObservableLocalStorageValue => update this.productIds
        const favoritesInLocalStorage = new ObservableLocalStorageVariable<number[]>({
            localStorageKey: 'AnonymousFavorites',
            // validatorFunction: (newValue) => { // validator
            //     if(newValue === undefined) return true
            //     if(Data.isArray(newValue)) return true
            //     return false
            // }
        })
        favoritesInLocalStorage.eventOnChange.subscribe(async (newValue) => {
            const currentValueAsJsonString = this.toJsonString()
            const newValueInLocalStorageAsString = JSON.stringify(newValue)
            if (currentValueAsJsonString !== newValueInLocalStorageAsString) {
                // we have a new basket from other window
                await this.initFromArrayAsync(newValue as [])
                // this.productIdsO.set(newValue as [])
                // this.productIds.initFromArray(newValue as [])
                await this.onChangeEvent.triggerAsync()
            }

        })
        //#endregion

        //#region init this.productIds from localStorage
        const currentValueInLocalStorage = favoritesInLocalStorage.get()
        if (currentValueInLocalStorage) {
            // this.productIdsO.set(currentValueInLocalStorage as [])
            void this.initFromArrayAsync(currentValueInLocalStorage)
            this.prevIsEmpty = this.productIdsO.length === 0
            //console.log('prevIsEmpty=', this.prevIsEmpty)
        }
        //#endregion


        //#region trigger this.onFavoritesEmptyOrNotEvent if needed
        this.onChangeEvent.subscribe(async () => {
            const isEmptyNow = this.productIdsO.length === 0
            if (this.prevIsEmpty !== isEmptyNow) {
                await this.onFavoritesEmptyOrNotEvent.triggerAsync(isEmptyNow)
                this.prevIsEmpty = isEmptyNow
            }
        })
        //#endregion

        //#region when modify this.productIds => update localStorage && trigger this.onChangeEvent
        this.productIdsO.eventOnChange.subscribe(async (product) => {
            favoritesInLocalStorage.set(this.productIdsO.getAsArray())
            await this.onChangeEvent.triggerAsync()
        })
        //#endregion


        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.onChangeEvent.triggerAsync()

    }
    protected productIdsToRemove = new Set<number>()
    markProductToRemove(productId:number){
        this.productIdsToRemove.add(productId)
    }

    unmarkProductToRemove(productId:number){
        this.productIdsToRemove.delete(productId)
    }

    unmarkAllProducts(){
        this.productIdsToRemove.clear()
    }


    async removeMarkedProductsAsync():Promise<void>{
        for(let productId of this.productIdsToRemove){
            await this.removeAsync(productId)
        }
        this.productIdsToRemove.clear()
    }

    getProductIds(): number[] {
        return this.productIdsO.getAsArray()
    }
    getTotalQuantity(): number {
        return this.productIdsO.length
    }

    

    async addAsync(productId:number) {
        if(this.productIdsO.indexOf(productId) >= 0){
            // we have already
            console.warn('already have product in localstorage favorites', productId)
            return false
        }
        this.productIdsO.push(productId)
        return true
    }


    async removeAsync(productId:number) {
        this.productIdsO.set(this.productIdsO.filter(x=> x !== productId))
        return true
    }

    // protected productsToRemove:JsonMap<JsonBasketProductInfo, boolean> = new JsonMap<JsonBasketProductInfo, boolean>()

    async clearAsync() {
        this.productIdsO.set([])
        return true
    }

    toJsonString(): string {
        return JSON.stringify(this.productIdsO.getAsArray())
    }

    initFromJsonString(jsonString: string) {
        const asArray = JSON.parse(jsonString)
        if(!Array.isArray(asArray)){
            console.warn('unable to initFromJsonString. not an array', jsonString)
            this.productIdsO.set([])
            return
        }
        void this.initFromArrayAsync(asArray)
        // this.productIdsO.set(asArray)
    }

    async initFromArrayAsync(array:any[]){
        this.productIdsO.set(array)
        await this.removeObsoleteProductsAsync()
    }

    /**
     * Remove products that are not available for this user
     */
    async removeObsoleteProductsAsync(){
        const productIds:number[] = this.productIdsO.getAsArray()
        
        const availableProductIds = await ServerProducts.validateProductIds(productIds, GlobalState.productShowZeroQuantityProductsO.get() ?? false)
        // console.log('productIds=', productIds, 'availableProductIds=', availableProductIds)
        this.productIdsO.set(productIds.filter(productId => availableProductIds.includes(productId)))
    }



    getHash(): number {
        return StringMethods.getSimpleHash(this.toJsonString())
    }

    isEmpty() {
        //console.log('@@ this.productIds=', this.productIds)
        return this.productIdsO.length === 0
    }

    isInitialized(){
        return true
    }

    async hasProductIdAsync(productId: number): Promise<boolean> {
        return this.productIdsO.getAsArray().indexOf(productId)>=0
    }

}
